import React, { useState, useEffect } from 'react';
import { useAuthStore } from '../../stores/authStore';
import { useNavigate } from 'react-router-dom';
import { cloudLoginAPI } from '../../services/authService';
import PersonIcon from '@mui/icons-material/Person';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CircularProgress from '@mui/material/CircularProgress';
import styles from './LoginPage.module.css';
import cloudStyles from './CloudLoginPage.module.css';

const CloudLoginPage: React.FC = () => {
    const [usuario, setUsuario] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const { login, isAuthenticated } = useAuthStore();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/aws-pedidos');
        }
    }, [isAuthenticated, navigate]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const responseData = await cloudLoginAPI(usuario, password);

            if (responseData.token) {
                login(responseData);
                navigate('/aws-pedidos');
            } else {
                setError('Falha no login. Token não recebido.');
            }
        } catch (err) {
            setError('Usuário ou senha inválidos. Tente novamente.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={styles.loginContainer}>
            <div className={`${styles.loginWidget} ${cloudStyles.loginWidget}`}>
                <div className={`${styles.loginWidgetForm} ${cloudStyles.loginWidgetForm}`}>
                    <img src="/logo-nome.png" alt="Logo Kadesh" className={styles.logo} />

                    {error && <div className={styles.errorMessage}>{error}</div>}

                    <form onSubmit={handleSubmit}>
                        <div className={styles.inputGroup}>
                            <label htmlFor="username">Usuário</label>
                            <div className={styles.inputWithIcon}>
                                <PersonIcon className={styles.inputIcon} sx={{ fontSize: 18 }} />
                                <input
                                    type="text"
                                    id="username"
                                    placeholder="Digite seu usuário"
                                    value={usuario}
                                    onChange={(e) => setUsuario(e.target.value)}
                                    required
                                    autoFocus
                                />
                            </div>
                        </div>

                        <div className={styles.inputGroup}>
                            <label htmlFor="password">Senha</label>
                            <div className={styles.inputWithIcon}>
                                <LockOutlinedIcon className={styles.inputIcon} sx={{ fontSize: 18 }} />
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    id="password"
                                    placeholder="••••••••"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                <button
                                    type="button"
                                    className={styles.togglePassword}
                                    onClick={() => setShowPassword(!showPassword)}
                                    aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                                >
                                    {showPassword ? <VisibilityOffIcon sx={{ fontSize: 18 }} /> : <VisibilityIcon sx={{ fontSize: 18 }} />}
                                </button>
                            </div>
                        </div>

                        <button
                            type="submit"
                            className={styles.signInButton}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <CircularProgress size={18} color="inherit" className={styles.spinner} />
                                    Entrando...
                                </>
                            ) : (
                                'Entrar'
                            )}
                        </button>
                    </form>

                    <p className={styles.footer}>© {new Date().getFullYear()} TODOS OS DIREITOS RESERVADOS</p>
                </div>
            </div>
        </div>
    );
};

export default CloudLoginPage;
